<script>
    import { navigate } from "svelte-routing";
    export let url;
    export let title;
    export let img_url;
    export let aspectRatio = 60;

    function open (event) {
        navigate(url);
    }
</script>

<button on:mouseup={open} class="thumbnail" draggable="false" style="padding-top: {aspectRatio}%;">
    <div class="img-wrapper" style="background-image: url(/images/{img_url})"></div>
    <div class="overlay"></div>
    <span class="name">{title}</span>
</button>

<style>
    .thumbnail {
        display: block;
        width: 100%;
        box-sizing: border-box;
        color: white;
        position: relative;
        text-align: center;
        border-radius: 0.6rem;
        overflow: hidden;
        background-color: #242424;
    }

    .img-wrapper {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    .name {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 1rem;
        background: rgb(0,0,0);
        /* background: linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 100%); */
        background: linear-gradient(0, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 100%);
    }

    .more {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 1rem;
        background: rgb(0,0,0);
        background: linear-gradient(0, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 100%);
        opacity: 0.5;
        font-size: 0.8rem;
    }

    .overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        background: rgb(0,0,0);
        background: linear-gradient(0, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%);
    }
</style>